const CloseFullScreenIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 16 16' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10 5.14648L10 2.35352L9 2.35352L9 6.85352L13.5 6.85352L13.5 5.85352L10.707 5.85352L14.8535 1.70703L14.1465 1L10 5.14648Z'
        fillRule='evenodd'
        stroke='none'
      />
      <path
        d='M5.85352 10.707L5.85352 13.5L6.85352 13.5L6.85352 9L2.35352 9L2.35352 10L5.14649 10L1 14.1465L1.70703 14.8535L5.85352 10.707Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default CloseFullScreenIcon;
